import { CachePostfix } from '@/config'
import Storage from '@/utils/storage'
let CacheDataPostfix = CachePostfix + 'data_'
/**
 * 设置缓存
 * @param  {[type]} k [键名]
 * @param  {[type]} v [键值]
 * @param  {[type]} t [时间、单位秒]
 */
function add(k, v, t) {
    Storage.set(CacheDataPostfix + k, v)
    let seconds = parseInt(t)
    if (seconds > 0) {
        let timestamp = Date.parse(new Date())
        timestamp = timestamp / 1000 + seconds
        Storage.set(CachePostfix + k, timestamp)
    } else {
        Storage.remove(CachePostfix + k)
    }
}

/**
 * 获取缓存
 * @param  {[type]} k   [键名]
 * @param  {[type]} def [获取为空时默认]
 */
function get(k, def) {
    let deadtime = parseInt(Storage.get(CachePostfix + k))
    if (deadtime) {
        if (parseInt(deadtime) < Date.parse(new Date()) / 1000) {
            if (def) {
                return def
            } else {
                del(k)
                return false
            }
        }
    }
    let res = Storage.get(CacheDataPostfix + k)
    if (res) {
        return res
    } else {
        if (def === undefined || def === '') {
            def = false
        }
        return def
    }
}

function del(k) {
    Storage.remove(CacheDataPostfix + k)
    Storage.remove(CachePostfix + k)
}

/**
 * 清理所有缓存
 * @return {[type]} [description]
 */
function clear() {
    Storage.removeAll()
}

export default {
    add: add,
    get: get,
    del: del,
    clear: clear
}
